import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLoading: false,
    banners: [],
    aboutUs: null,
    partners: [],
    products: [],
    projects: [],
    // jobs: [],
    // email1: '',
    // email2: '',
    roles: [],
    worldViews: [],
    news: [],
    lives: [],
    // joinUsContent: '',
    // businessContent: ''
    contactUs: null
  },
  mutations: {
    showLoading (state, isLoading) {
      state.isLoading = isLoading
    },
    setBanners (s, a) {
      s.banners = a
    },
    setAboutUs (s, o) {
      s.aboutUs = o
    },
    setPartners (s, a) {
      s.partners = a
    },
    setProducts (s, a) {
      s.products = a
    },
    setProjects (s, a) {
      s.projects = a
    },
    // setJobs (s, a) {
    //   s.jobs = a
    // },
    // setEmail1 (s, e) {
    //   s.email1 = e
    // },
    // setEmail2 (s, e) {
    //   s.email2 = e
    // },
    setRoles (s, a) {
      s.roles = a
    },
    setWorldViews (s, a) {
      s.worldViews = a
    },
    setNews (s, a) {
      s.news = a
    },
    setLives (s, a) {
      s.lives = a
    },
    // setJoinUsContent (s, c) {
    //   s.joinUsContent = c
    // },
    // setBusinessContent (s, c) {
    //   s.businessContent = c
    // },
    setContactUs (s, o) {
      s.contactUs = o
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js